import { useEffect, useState } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFormatedPhoneNumber } from "@utility/helperFunction";
import { getObjectValue } from "@utility/utills";
import { generateTextToPay } from "../../../../reducers/fireboard";
import cn from "classnames";
import style from "./bulkTextToPay.module.scss";
import { ReactComponent as SuccessIcon } from '@assets/images/check_circle.svg';
import { ReactComponent as CrossIcon } from '@assets/images/receiptCancel.svg';
import { Oval } from 'react-loader-spinner';
import {
  getPickUpTimeInHrsMins,
} from "@utility/fireboardUtil";
import HamHeader from "../Header/HamburgerHeader";
import { goToView } from "../../../../utility/fireboardUtil";
import { FLABEL } from '@containers/Fireboard/fireboardVariables';
import { setNotification } from '@reducers/notification';

const BulktextToPay = (props) => {
  const { bulkTextToPayChecks, closePopup } = useOutletContext();
  const { currency, countryCode, currentView } = props;
  const [bulkChecks, setBulkChecks] = useState(new Map());
  const [isAllSelected, setIsAllSelected] = useState(false);
  const storeInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem("auth"), false),
  );
  const deviceInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem("deviceInfo"), false),
  );
  const navigate = useNavigate();

  useEffect(() => {
    let bulkChecks = new Map();
    bulkTextToPayChecks &&
      bulkTextToPayChecks?.current?.forEach((check) => {
        bulkChecks.set(check.id, {
          ...check,
          textToPayStatus: "",
          textToPayErrorMsg: "",
          isSelected: false,
          isPreAuth: isCheckPreAuth(check),
        });
      });
    setBulkChecks(bulkChecks);
  }, [bulkTextToPayChecks]);

  const isCheckPreAuth = (check) => {
    const { tickets, unpaidAmount } = check;
    const preAuthTicket =
      tickets &&
      tickets?.find(
        (ticket) =>
          ticket.ticketStatusId === 0 && ticket.preAuth && unpaidAmount > 0,
      );
    const isPreAuth = preAuthTicket ? true : false;
    return isPreAuth;
  };

  const onHandleCheckBox = (id) => {
    const copiedChecks = new Map(bulkChecks);
    if (copiedChecks.has(id)) {
      const check = copiedChecks.get(id);
      copiedChecks.set(id, { ...check, isSelected: !check?.isSelected });
      setBulkChecks(copiedChecks);
    }
  };
  const handlePhoneNumbers = (phnNumber, id) => {
    const copiedChecks = new Map(bulkChecks);
    const check = copiedChecks.get(id);
    copiedChecks.set(id, {
      ...check,
      phoneNumber: phnNumber,
    });
    setBulkChecks(copiedChecks);
  };
  const returnMaxLength = (countryCode) => {
    if (Number(countryCode) === 1) {
      return 12;
    }
    return 15;
  };

  const handleSelectAll = () => {
    const checksArray =
      bulkChecks instanceof Map ? Array.from(bulkChecks.values()) : [];
    const allSelected = checksArray?.every((check) => check.isSelected);
    const copiedChecks = new Map(bulkChecks);
    if (!allSelected) {
      checksArray?.forEach((check) =>
        copiedChecks.set(check.id, { ...check, isSelected: true }),
      );
    } else {
      checksArray?.forEach((check) =>
        copiedChecks.set(check.id, { ...check, isSelected: false }),
      );
    }
    setBulkChecks(copiedChecks);
  };

  const isSubmitBtnDisabled = () => {
    const checksArray =
      bulkChecks instanceof Map ? Array.from(bulkChecks.values()) : [];
    return !checksArray.some((chk) => chk.isSelected);
  };
  const getPayload = (check) => { 
    return {
      latitude: "32",
      longitude: "32",
      deviceId: deviceInfo?.deviceId,
      storeId: storeInfo.id,
      guestName: check?.guestName || "",
      phoneNumber: check.phoneNumber,
      checkNumber: check.number,
      subtotalAmount: check.subTotalAmount,
      taxAmount: +check.taxAmount,
      pickupTime: getPickUpTimeInHrsMins(check.pickupDate),
      countryCode: check?.orders[0]?.countryCode || countryCode,
      checkHeaderId: check.id,
      preAuth: check.isPreAuth || false,
    };
  };

  const onSubmit = async () => {
    const checksArray = Array.from(bulkChecks.values());
    const filteredChecks = checksArray.filter((check) => check.isSelected);

    const cpChecks = new Map(bulkChecks);

    filteredChecks?.forEach((check) => {
      cpChecks.set(check.id, {
        ...check,
        textToPayStatus: "loading",
        textToPayErrorMsg: FLABEL().BULK_PROCESSING_TEXT_TO_PAY.replace("{{CheckNo}}", check.number),
      });
    });

    setBulkChecks(cpChecks);

    const promises = filteredChecks.map((check) =>
      props
        .generateTextToPay(getPayload(check))
        .then((response) => ({ status: "fulfilled", value: response, check }))
        .catch((error) => ({ status: "rejected", reason: error, check })),
    );

    const results = await Promise.all(promises).then(() => {
      props.setNotification({
        type: 'success',
        message: FLABEL().TOAST_SMS_SUCCESS,
      });
    });
    const copiedChecks = new Map(bulkChecks);

    results?.forEach((result) => {
      const { check } = result;

      if (result.status === "fulfilled") {
        const updatedCheck = result.value;
        const existingCheck = copiedChecks.get(updatedCheck.id);
        copiedChecks.set(updatedCheck.id, {
          ...existingCheck,
          textToPayStatus: "success",
          textToPayErrorMsg: "",
          isSelected: false,
        });
      } else if (result.status === "rejected") {
        const error = result.reason;
        console.log({ error });

        const errorMsg =
          error?.response?.data?.message || error?.message || "Unknown error";
        const existingCheck = copiedChecks.get(check.id);
        copiedChecks.set(check.id, {
          ...existingCheck,
          textToPayStatus: "error",
          textToPayErrorMsg: errorMsg,
        });
      }
    });

    setBulkChecks(copiedChecks);
  };

  const getStatus = status => {
    let statusJSX = null;
    if(status){
        if(status === 'loading'){
            statusJSX = <Spinner/>
        }else if(status === 'success'){
            statusJSX = <SuccessIcon/>
        }else if(status === 'error'){
            statusJSX = <CrossIcon/>
        }
    }

    return statusJSX
  }

  const renderContent = (check, index) => {
    const {
      id,
      number,
      stationName,
      employeeFirstName,
      employeeLastName,
      totalAmount,
      isSelected,
      textToPayStatus = "",
      textToPayErrorMsg = "",
      phoneNumber,
    } = check;
    return (
      <div
        className={cn(
          style.contentTxt,
          style.gridContainer,
          (index & 1) === 0
            ? `${style.evenIndexTabBg}`
            : `${style.oddIndexTabBg}`,
          style.tBodyContainer,
        )}
        key={`ticket-${check.id}`}
      >
        <div className={cn(style.headerTiltle, style.flex03, "pl-2")}>
          <input
            checked={isSelected}
            className={style.input}
            type="checkbox"
            onChange={() => onHandleCheckBox(id)}
          />
        </div>
        <div className={cn(style.headerTiltle, style.flex1)}>{number}</div>
        <div className={cn(style.headerTiltle, style.flex1)}>{stationName}</div>
        <div className={cn(style.headerTiltle, style.flex1,
          style.truncate, 'col-12 px-0 text-center'
        )}>
          {employeeFirstName} {employeeLastName}
        </div>
        <div className={cn(style.headerTiltle, style.flex1)}>
          {currency}
          {totalAmount?.toFixed(2)}
        </div>
        <div className={cn(style.headerTiltle, style.flex1)}>
          <input
            type="tel"
            className={style.PhoneNumberInput}
            maxLength={returnMaxLength(countryCode)}
            value={phoneNumber ? getFormatedPhoneNumber(phoneNumber) : ""}
            onChange={(e) => handlePhoneNumbers(e.target.value, id)}
          />
        </div>
        <div className={cn(style.headerTiltle, style.flex1, style.statusIcon)}>{getStatus(textToPayStatus)}</div>
        <div className={cn(style.headerTiltle, style.flex1, 'px-3 text-center')}>
          {textToPayErrorMsg}
        </div>
      </div>
    );
  };
  const checksArray =
    bulkChecks instanceof Map ? Array.from(bulkChecks.values()) : [];    
  return (
    <div className="w-100 h-100 position-relative text-white p-3">
      <HamHeader
        label={FLABEL().HEADER_BULK_TEXT_TO_PAY}
        onClickback={() => {
          closePopup();
          goToView(currentView, navigate);
        }}
      />

      <div className={cn(style.receiptTableConatiner)}>
        <Header
          handleSelectAll={handleSelectAll}
          isAllSelected={isAllSelected}
          checksArray={checksArray}
        />
        <div className={cn("w-100 overflowY", style.tbodyWrapper)}>
          {checksArray?.map((check, index) => renderContent(check, index))}
        </div>
      </div>
      <div
        className={cn(
          "w-100 d-flex justify-content-center align-items-center position-absolute pb-1",
          style.btnContainer,
        )}
      >
        <button
          disabled={isSubmitBtnDisabled()}
          onClick={onSubmit}
          className={cn(style.btn, style.receiptBtn)}
        >
          {FLABEL().BULK_SUBMIT}
        </button>
      </div>
    </div>
  );
};
const mapStateToProps = ({ oauth }) => ({
  currentView: oauth.currentView,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      generateTextToPay,
      setNotification
    },
    dispatch,
  );
export default connect(mapStateToProps, mapDispatchToProps)(BulktextToPay);

const Header = ({ handleSelectAll, isAllSelected, checksArray }) => {
  return (
    <div className={cn("text-center", style.contentTxt, style.headerContainer, style.gridContainer)}>
      <div className={cn(style.headerTiltle, style.flex03, "pl-2")}>
        <input
          checked={checksArray?.every((chk) => chk.isSelected)}
          className={style.input}
          type="checkbox"
          onChange={() => handleSelectAll()}
        />
      </div>
      <div className={cn(style.headerTiltle, style.flex1)}>
        {FLABEL().BULK_CHECK}
      </div>
      <div className={cn(style.headerTiltle, style.flex1)}>
        {FLABEL().BULK_TABLE}
      </div>
      <div className={cn(style.headerTiltle, style.flex1)}>
        {FLABEL().BULK_EMPLOYEE}
      </div>
      <div className={cn(style.headerTiltle, style.flex1)}>
        {FLABEL().BULK_TOTAL}
      </div>
      <div className={cn(style.headerTiltle, style.flex1)}>
        {FLABEL().BULK_PHONE_NUMBER}
      </div>
      <div className={cn(style.headerTiltle, style.flex1)}>
        {FLABEL().BULK_STATUS}
      </div>
      <div className={cn(style.headerTiltle, style.flex1)}>
        {FLABEL().BULK_MESSAGE}
      </div>
    </div>
  );
};


const Spinner = () => {
   return (
     <Oval
        visible={true}
        height="30"
        width="30"
        color="#FFF"
        secondaryColor="#96AEFF"
        ariaLabel="oval-loading"
        strokeWidthSecondary=""
        wrapperStyle={{}}
        wrapperClass=""
    />
   )
}